// Kununu Store
import { objectTypeToType } from '@/helper'
import { upperFirst } from 'lodash'

const state = {
  kununu: {},
  pending: false,
}

const getters = {}

const object_types = ['kununu']

/* create actions dynamically */
const actions = {}
object_types.forEach(object_type => {
  actions['get' + upperFirst(objectTypeToType(object_type))] = function({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems(object_type)
      .then(({ data }) => {
        commit('SET_' + objectTypeToType(object_type).toUpperCase(), data)
        commit('SET_PENDING')
        resolve()
      })
    })
  }
})

/* create mutations dynamically */
const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
}
object_types.forEach(object_type => {
  mutations['SET_' + objectTypeToType(object_type).toUpperCase()] = function(state, payload) {
    state[objectTypeToType(object_type)] = payload
  }
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
